import React from "react";

// Hand-over 2D: the fixed list of what a scope line counts. The proposal's quantities, glance tiles and unit
// prices read tagged lines only; a line without a kind never prints as a quantity.
export const KINDS = [
  ["pile", "Pile"], ["pre_drill", "Pre-drill"], ["row", "Tracker row"], ["torque_tube_lf", "Torque tube (LF)"], ["module", "Module"],
  ["string", "String"], ["home_run", "Home run"], ["combiner", "Combiner"], ["feeder_lf", "Feeder (LF)"], ["trench_lf", "Trench (LF)"],
  ["conduit_lf", "Conduit (LF)"], ["cable_lf", "Cable (LF)"], ["dc_conductor_lf", "DC conductor (LF)"], ["ac_conductor_lf", "AC conductor (LF)"],
  ["mv_cable_lf", "MV cable (LF)"], ["termination", "Termination"], ["mv_splice", "MV splice"], ["skid", "Inverter skid"], ["inverter", "Inverter"],
  ["transformer", "Transformer"], ["pad", "Pad"], ["ground_lf", "Grounding (LF)"], ["ground_rod", "Ground rod"], ["fence_lf", "Fence (LF)"],
  ["fiber_lf", "Fiber (LF)"], ["test", "Test"], ["commissioning", "Commissioning"], ["handling", "Handling"], ["qa_qc", "QA/QC"],
  ["weather", "Weather"], ["survey", "Survey"], ["other", "Other"],
];
const NON_QTY = new Set(["qa_qc", "handling", "weather", "test", "commissioning", "other"]);

export function KindSelect({ value, onChange, disabled, testid, className = "" }) {
  return (
    <select value={value || ""} onChange={(e) => onChange(e.target.value || null)} disabled={disabled} data-testid={testid}
      className={`w-full text-xs border border-slate-200 rounded-lg px-2 py-1.5 bg-white focus:border-[#003E87] outline-none ${className}`}>
      <option value="">Not tagged</option>
      {KINDS.map(([k, lbl]) => <option key={k} value={k}>{lbl}</option>)}
    </select>
  );
}

// Line-level tag: kind + "counts as the quantity" flag (defaults on, except QA/QC, handling and the like).
export function LineKindFields({ line, onField, readOnly, hint = null }) {
  const kind = line.kind || "";
  const counts = line.counts_as_quantity == null ? (kind ? !NON_QTY.has(kind) : false) : !!line.counts_as_quantity;
  return (
    <div className="grid grid-cols-2 gap-3" data-testid={`kind-fields-${line.line_id}`}>
      <label className="block">
        <span className="text-[10px] text-slate-500">Counts as (proposal quantity tag)</span>
        <div className="mt-0.5"><KindSelect value={kind} onChange={(v) => onField("kind", v)} disabled={readOnly} testid={`kind-${line.line_id}`} /></div>
        {!kind && hint && !readOnly && (
          <button type="button" onClick={() => onField("kind", hint.kind)} data-testid={`kind-hint-use-${line.line_id}`}
            className="mt-1 text-[11px] text-slate-400 hover:text-[#003E87] inline-flex items-center gap-1" title="Suggested from the line's name; click to use it">
            Suggested: <span className="font-medium">{hint.label}</span> · use it
          </button>
        )}
      </label>
      <label className="flex items-end gap-2 pb-1.5 text-xs text-slate-700">
        <input type="checkbox" disabled={readOnly || !kind} checked={!!kind && counts} onChange={(e) => onField("counts_as_quantity", e.target.checked)}
          data-testid={`counts-${line.line_id}`} className="accent-[#003E87]" />
        <span>This line is the thing itself (prints as the quantity)</span>
      </label>
    </div>
  );
}
